import React, { Component } from 'react';
import moment from 'moment';

import TrafficSignsTestsForm from './TrafficSignsTestsForm';
import TrafficSignsSettingsForm from './TrafficSignsSettingsForm';
import TrafficSignsMessageForm from './TrafficSignsMessageForm';
import TrafficSignsActualView from './TrafficSignActualView';
import { defaultSorter, dateSorter } from './Helpers';
import TrafficSignsModel from './TrafficSignsModel';
import UserModel from './UserModel';

import { Table, Badge, C, Card, Divider, Row, Col, Statistic, Popconfirm, Typography, message } from 'antd';

class TrafficSignsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    trafficSignsMessageFormData: null,
    trafficSignsTestsFormData: null,
    trafficSignsSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={4}>
            <Card title="Typ">
              {record.defaultSettings.type}
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Barva pozadí">
              {record.defaultSettings.backgroundColor}
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Barva písma">
              {record.defaultSettings.color}
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Zarovnání">
              {record.defaultSettings.aligment}
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Platnost zprávy [min]">
              {record.defaultSettings.duration}
            </Card>
          </Col>
          <Col span={8}>
            <Card title='Událost'>
              {record.eventListener}
            </Card>
          </Col>
          <Col span={4}>
            <Card title="Typ značky">
              {record.type}
            </Card>
          </Col>
          <Col span={6}>
            <Card
              title="Aktuální zobrazení"
              height={40}>
              {!this.props.loading && <TrafficSignsActualView serialNumber={record.serialNumber} />}
            </Card>
          </Col>
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 250,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
    }, {
      title: 'Sériové číslo',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
      width: 120,
      sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Popis',
      dataIndex: 'description',
      key: 'description',
      width: 220,
    }, {
      title: 'Poslední komunikace',
      dataIndex: 'lastCommunication',
      key: 'lastCommunication',
      width: 200,
      sorter: (a, b) => dateSorter(a.lastCommunication, b.lastCommunication),
      render: (text, record) => {
        if (moment(record.lastCommunication) <= moment().subtract(61, "minutes")) {
          return (
            <Badge
              status="error"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než hodinou" />
          );
        } else if (moment(record.lastCommunication) <= moment().subtract(65, "seconds")) {
          return (
            <Badge
              status="warning"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než minutou" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={moment(text).format('L LTS')}
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Bat. alarm',
      dataIndex: 'lastStatesAlarm',
      key: 'lastStatesAlarm',
      width: 130,
      filters: [{
        text: 'ANO',
        value: true,
      }, {
        text: 'NE',
        value: false,
      }],
      filteredValue: filteredInfo.lastStatesAlarm || null,
      onFilter: (value, record) => { return ((record.lastStates.alarm === (value == 'true'))) ? true : false },
      render: (text, record) => {
        if (record.lastStates.alarm === true) {
          return (
            <Badge
              status="error"
              text="ANO"
              title="Baterie je téměř vybitá" />
          );
        } else {
          return (
            <Badge
              status="success"
              text="NE"
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Aktivní',
      dataIndex: 'active',
      key: 'active',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.active || null,
      onFilter: (value, record) => { return ((record.active === value)) ? true : false },
      render: (text, record) => {
        if (record.active === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO"
               />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO"
               />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 300,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'TRAFFICSIGNS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  trafficSignsMessageFormData: record
                });
              }}>Zpráva</a>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  trafficSignsTestsFormData: record
                });
              }}>Test</a>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  trafficSignsSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm
                placement="right"
                title="Opravdu si přejete svazek s touto tabulí restartovat?"
                okText="Ano"
                cancelText="Ne"
                onConfirm={() => {
                  TrafficSignsModel.restart(record.serialNumber)
                    .then(() => {
                      message.success('Na informační tabuli byl odeslán restart!');
                    })
                    .catch(() => {
                      message.error('Restart se nepodařilo odeslat!');
                    });
                }}>
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="warning">Restart</Typography.Text></a>
              </Popconfirm>
              <Divider type="vertical" />
              <Popconfirm
                placement="right"
                title="Opravdu si přejete tuto tabuli smazat?"
                okText="Ano"
                cancelText="Ne"
                onConfirm={() => {
                  TrafficSignsModel.remove(record.id)
                    .then(() => {
                      message.success('Informační tabule byla odstraněna!');
                      this.props.onRowRemoved();
                    })
                    .catch(() => {
                      message.error('Informační tabuli se nepodařilo smazat!');
                    });
                }}>
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)} />
        <TrafficSignsMessageForm
          type="modal"
          modalVisible={this.state.trafficSignsMessageFormData === null ? false : true}
          initialValues={this.state.trafficSignsMessageFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ trafficSignsMessageFormData: null });
          }}
          onSuccess={(form, values) => {
            form.resetFields();
            TrafficSignsModel.message(this.state.trafficSignsMessageFormData.serialNumber, values)
              .then(() => {
                message.success('Na značku '
                  + this.state.trafficSignsMessageFormData.serialNumber
                  + ' byl odeslána zpráva');
                form.resetFields();
                this.setState({
                  trafficSignsMessageFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Zprávu se nepodařilo odeslat.');
              });
          }} />
        <TrafficSignsTestsForm
          type="modal"
          modalVisible={this.state.trafficSignsTestsFormData === null ? false : true}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ trafficSignsTestsFormData: null });
          }}
          onSuccess={(form, values) => {
            TrafficSignsModel.test(this.state.trafficSignsTestsFormData.serialNumber, values)
              .then(() => {
                message.success('Na značku ' + this.state.trafficSignsTestsFormData.serialNumber
                  + ' byl odeslán test: ' + values.test
                  + ' v barvě: ' + values.color
                  + ' na dobu ' + values.time + 's');
                form.resetFields();
                this.setState({
                  trafficSignsTestsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Test se nepodařilo odeslat. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
        <TrafficSignsSettingsForm
          type="modal"
          modalVisible={this.state.trafficSignsSettingsFormData === null ? false : true}
          initialValues={this.state.trafficSignsSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ trafficSignsSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            let data = Object.assign({}, this.state.trafficSignsSettingsFormData, values)
            TrafficSignsModel.update(this.state.trafficSignsSettingsFormData.id, data)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  trafficSignsSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default TrafficSignsTable;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsTable.js